function resolveChatApiBaseUrl(raw: string | undefined): string {
  const value = raw?.trim() ?? '';
  if (!value) {
    return '';
  }

  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    const isLoopback =
      host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1';

    if (isLoopback || (url.protocol !== 'http:' && url.protocol !== 'https:')) {
      return '';
    }

    return url.href.endsWith('/') ? url.href : `${url.href}/`;
  } catch {
    return '';
  }
}

// Only a public API URL is used. A localhost fallback would make Chrome on
// Android prompt visitors to "access other apps and services on this device".
export const API_BASE_URL = resolveChatApiBaseUrl(import.meta.env.VITE_API_BASE_URL);
export const isChatApiConfigured = API_BASE_URL !== '';
